import InternalChatChannelsAPI from '../../../api/internalChatChannels';

const state = {
  records: {},
};

export const getters = {
  getUserList: $state => channelId => {
    return $state.records[Number(channelId)] || [];
  },
};

export const actions = {
  toggleTyping: async (_, { status, channelId }) => {
    try {
      await InternalChatChannelsAPI.toggleTypingStatus(channelId, status);
    } catch (error) {
      // Handle error
    }
  },
  addTypingUser: ({ commit, state: _state }, { channelId, user }) => {
    const records = _state.records[channelId] || [];
    const hasUser = records.some(r => r.id === user.id);
    if (!hasUser) {
      commit('ADD_TYPING_USER', { channelId, user });
    }
  },
  removeTypingUser: ({ commit }, { channelId, userId }) => {
    commit('REMOVE_TYPING_USER', { channelId, userId });
  },
};

export const mutations = {
  ADD_TYPING_USER: ($state, { channelId, user }) => {
    const records = $state.records[channelId] || [];
    $state.records = {
      ...$state.records,
      [channelId]: [...records, user],
    };
  },
  REMOVE_TYPING_USER: ($state, { channelId, userId }) => {
    const records = $state.records[channelId] || [];
    $state.records = {
      ...$state.records,
      [channelId]: records.filter(r => r.id !== userId),
    };
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
